import { FaInstagram } from "react-icons/fa";
import { PrimaryButton } from "./PrimaryButton";

export const InstagramSection = () => {
  const instagramPosts: { href: string; src: string }[] = [
    {
      href: "/ergotherapie_rottweil/p/DTwuzoHjJm6/",
      src: "/images/instagram/post-new-1.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DTdDiriDErG/",
      src: "/images/instagram/post-new-2.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DTXEz6AjNOA/",
      src: "/images/instagram/post-new-3.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DTCjQJ_jPEt/",
      src: "/images/instagram/post-new-4.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DTBH5tzDMhl/",
      src: "/images/instagram/post-new-5.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DS5NZP3DICP/",
      src: "/images/instagram/post-new-6.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DS3ACy8CEAA/",
      src: "/images/instagram/post-new-7.jpg",
    },
    {
      href: "/ergotherapie_rottweil/p/DSjlu54DKRQ/",
      src: "/images/instagram/post-new-8.jpg",
    },
  ];
  return (
    <div className="relative">
      <div className="px-6 pt-8 sm:px-8 lg:px-12">
        <div className="relative mx-auto">
          {/* Card Container */}
          <div
            className="relative bg-white dark:bg-gray-800/60 rounded-3xl shadow-sm border border-gray-200/60 dark:border-gray-700/40 p-10 sm:p-12"
          >
            {/* Header Section */}
            <div className="text-center space-y-8">
              {/* Instagram Icon */}
              <div className="flex justify-center">
                <div
                  className="p-3.5 rounded-xl bg-ergo-50 dark:bg-ergo-900/60"
                >
                  <FaInstagram className="h-7 w-7 text-ergo-600 dark:text-ergo-400" />
                </div>
              </div>

              {/* Text Content */}
              <div className="space-y-4">
                <h2 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
                  Folgen Sie uns auf Instagram
                </h2>
                <p className="text-base text-gray-600 dark:text-gray-300 max-w-xl mx-auto font-medium">
                  Bleiben Sie auf dem Laufenden über unsere Praxis und erhalten Sie wertvolle Tipps.
                </p>
              </div>

              {/* Preview grid */}
              <div className="mx-auto max-w-4xl">
                <div className="mb-2 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
                  {instagramPosts.slice(0, 8).map((post, idx) => (
                    <a
                      key={idx}
                      href={`https://www.instagram.com${post.href}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-800"
                      aria-label={`Instagram Beitrag ${idx + 1}`}
                    >
                      <img
                        src={post.src}
                        alt={`Ergotherapie Rottweil - Instagram Beitrag ${idx + 1}: Einblicke in unsere therapeutische Arbeit`}
                        className="w-full h-full object-cover aspect-square transition-transform duration-300 hover:scale-105"
                        loading="lazy"
                      />
                    </a>
                  ))}
                </div>
              </div>

              {/* Follow Button */}
              <div className="pt-4">
                <PrimaryButton
                  href="https://www.instagram.com/ergotherapie_rottweil"
                >
                  <FaInstagram className="h-4 w-4" />
                  <span className="ml-2">Auf Instagram folgen</span>
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
